import { useEffect } from 'react';
import RgHeader from './components/RgHeader';
import RgHero from './components/RgHero';
import OverviewSection from './components/OverviewSection';
import ConceptsSection from './components/ConceptsSection';
import SpecsSection from './components/SpecsSection';
import PortalSection from './components/PortalSection';
import RewardsSection from './components/RewardsSection';
import FundingSection from './components/FundingSection';
import PublicBenefitSection from './components/PublicBenefitSection';
import FounderSection from './components/FounderSection';
import HistoricalEvidenceSection from './components/HistoricalEvidenceSection';
import FaqSection from './components/FaqSection';
import BookshelfSection from './components/BookshelfSection';
import NextBookSection from './components/NextBookSection';
import StatusSection from './components/StatusSection';
import ContactSection from './components/ContactSection';
import RgFooter from './components/RgFooter';

export default function RevolvingGate() {
  useEffect(() => {
    document.title = '《1001旋轉門 Revolving Gate》｜出版募款計畫';
  }, []);

  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-900">
      <RgHeader />
      <main>
        <RgHero />
        <OverviewSection />
        <ConceptsSection />
        <SpecsSection />
        <PortalSection />
        <RewardsSection />
        <FundingSection />
        <PublicBenefitSection />
        <FounderSection />
        <HistoricalEvidenceSection />
        <FaqSection />
        <BookshelfSection />
        <NextBookSection />
        <section aria-label="旋轉門階段目標" className="relative isolate flex min-h-[360px] items-end overflow-hidden md:min-h-[480px]">
          <img src="/images/trilogy/rg-gate.jpg" alt="黃色旋轉門" loading="lazy" className="absolute inset-0 -z-20 h-full w-full object-cover" />
          <div className="absolute inset-0 -z-10 bg-gradient-to-t from-white/95 via-white/25 to-transparent" />
          <p className="mx-auto max-w-2xl px-5 pb-10 text-center text-lg text-foreground-900 md:text-2xl" style={{ fontFamily: 'var(--font-heading)' }}>
            從生命樹出發，整合 1D–5D；經過一年的生活實踐，走向旋轉門。
          </p>
        </section>
        <StatusSection />
        <ContactSection />
      </main>
      <RgFooter />
    </div>
  );
}
